import Api from '@/api/Api'
import store from '../store'

export default {

  async getList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('settings/role-permissions', { params }))
  },

  async getSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`settings/role-permissions/${id}`))
  },

  async insert (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('settings/role-permissions', data, options))
  },

  async update (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`settings/role-permissions/${id}`, data, options))
  },

  async delete (id = '') {
    return store.dispatch('checkResponseApi', await Api().delete(`settings/role-permissions/${id}`))
  },
}



// WEBPACK FOOTER //
// ./src/api/RolePermission.js